import React from 'react';
import { useDispatch } from 'react-redux';
import Button from '@material-ui/core/Button';
import stylesParent from '../../../styles/frame/frame.module.scss';
import styles from '../../../styles/unstake/unstake-information.module.scss';
import Header from '../../../../../../../components/Stake/header';
import * as omPolygonStakeActions from '../../../../../../../actions/om-stake-actions-polygon';
import { useGetTheme } from '../../../../../../../hooks/useGetTheme';
import OmIcon from '../../../../../../../assets/images/tokens/om.svg';
import { OM } from '../../../../../../../constants/blockchain-constants';
import cn from 'classnames';

const UnstakeInformation = () => {
  const dispatch = useDispatch();
  const colors = useGetTheme();

  return (
    <>
      <Header
        icon={OmIcon}
        title={`${OM}-Unstaking`}
        onClickBack={() => dispatch(omPolygonStakeActions.unstakeSettings())}
      />
      <div
        className={cn(stylesParent.cardContent, styles.unstaking)}
        style={{ color: colors.text }}
      >
        <div className={styles.title}>Withdrawal Timer Reset!</div>
        <div className={styles.description}>
          If you are currently unstaking and decide to unstake more tokens half way through, the
          timer will be reset to 8 days, and you will be able to withdraw both set of tokens after 8
          days.
        </div>
        <Button
          onClick={() => dispatch(omPolygonStakeActions.unstakeDetails())}
          variant='contained'
          color='secondary'
          className={cn(stylesParent.cardFooterControlsButton, styles.button)}
        >
          Continue
        </Button>
        <div className={styles.description}>
          <span>IMPORTANT:</span>&nbsp;
          <b>
            You are able to unstake your tokens immediately by paying a 2% fee on your current
            unstaking amount.
          </b>
        </div>
        <Button
          onClick={() => dispatch(omPolygonStakeActions.unstakeImmediatelyDetails())}
          variant='contained'
          color='secondary'
          className={cn(stylesParent.cardFooterControlsButton, styles.button)}
        >
          Unstake Immediately
        </Button>
      </div>
    </>
  );
};

export default UnstakeInformation;
